import { useState, ReactNode } from 'react';
import CollectionsAPI, { Item } from '../../api/CollectionsAPI';
import { Autocomplete } from '../Autocomplete/Autocomplete';
import { BolderText } from '../BolderText/BolderText';
import ListElement from '../ListElement/ListElement';
import { isImageFile } from '../../shared/fileUtils';

type Props = {
  onChange: (input: any) => void,
  filterDress?: (dress: Item) => boolean,
  label?: string,
  placeholder?: string,
  defaultValue?: string,
  isDisabled?: boolean,
  errorMessage?: string,
  emptyResultsContent?: ReactNode
};

export function ItemAutocomplete({ 
  onChange = () => null, 
  filterDress = () => true, 
  label = '', 
  placeholder = '', 
  defaultValue = '', 
  isDisabled = false, 
  errorMessage = '',
  emptyResultsContent = null
}: Props) {

  const [loadingSearch, setLoadingSearch] = useState(false);
  const [showEmptyContent, setShowEmptyContent] = useState(false);
  
  const search = (input: string, resultsSize: number, setResultsFn: any) => {
    setLoadingSearch(true);
    CollectionsAPI.searchItems(input.toLowerCase()).then((resp) => {
      const raw = resp.data.filter(filterDress);
      const respRaw = raw.slice(0, resultsSize);
      setLoadingSearch(false);
      setResultsFn(respRaw);
      setShowEmptyContent(respRaw.length === 0 && !!emptyResultsContent);
    });
  };

  return (
    <div>
      <Autocomplete
        resultsSize={15}
        searchFn={search}
        onSelect={onChange}
        label={label} 
        placeholder={placeholder} 
        isLoading={loadingSearch}
        errorMessage={errorMessage || "global.empty_results"}
        toElementFn={(dress: Item) => {
          const firstImage = dress.media ? dress.media.find(m => isImageFile(m)) : null;
          const fallbackMedia = dress.media && dress.media.length > 0 ? dress.media[0] : null;
          const imageUrl = firstImage || fallbackMedia;
          
          return (
            <ListElement key={dress.id}>
                <div className="flex space-x-3 items-center">
                  { imageUrl && <img className="w-[30px] min-h-[30px] rounded shadow" src={imageUrl} alt="Dress option" /> }
                  <p className="bolder">{dress.name}&nbsp;</p>{ dress.collectionName && <BolderText text={` (${dress.collectionName})`} />}
                </div>
            </ListElement>
          );
        }}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
      />
      
      {showEmptyContent && (
        <div className="mb-2 text-sm">
          {emptyResultsContent}
        </div>
      )}
    </div>
  );
}
